/**
 * Inputs, checkbox and radiobox
 */
$(function() {

  /* Radiobox */

  const $radiobox_input = $('.radio-box input[type="radio"]');

  function radiobox_state () {
    $('input[name="' + $(this).attr('name') + '"]').each(function () {
      $(this).is(':checked') ? $(this).parents('.radio-box').addClass('checked') : $(this).parents('.radio-box').removeClass('checked');
    });
    $('.radio-box:not(.checked) input[type="text"]').prop('disabled', true);
    $('.radio-box.checked input[type="text"]').prop('disabled', false);
  }

  $radiobox_input.on('change', radiobox_state);
  $radiobox_input.each(radiobox_state); // Init

  /* Checkbox  */

  const $checkbox_input = $('.check-box input');

  function checkbox_state () {
    $(this).is(':checked') ? $(this).parents('.check-box').addClass('checked') : $(this).parents('.check-box').removeClass('checked');
  }

  $checkbox_input.on('change', checkbox_state);
  $checkbox_input.each(checkbox_state); // Init

  /* Inputs */

  const $textbox_input = $('.text-box input');

  function textbox_state () {
    if (($(this).val() || '').length > 0) {
      $(this).addClass('filled');
    } else {
      $(this).removeClass('filled');
    }
  }

  $textbox_input.on('change', textbox_state);
  $textbox_input.each(textbox_state); // Init

  /* Select */

  const $selectbox_select = $('.select-box select');

  function selectbox_state () {
    if (($(this).val() || '').length > 0) {
      $(this).addClass('filled');
    } else {
      $(this).removeClass('filled');
    }
  }

  $selectbox_select.on('change', selectbox_state);
  $selectbox_select.each(selectbox_state); // Init

  /* Inputs range */

  const $slider_input = $('.slider-box input');

  function slider_state () {
    $(this).next().css('width',  $(this).val()+'%')
  }

  $slider_input.on('input change', slider_state);
  $slider_input.each(slider_state); // Init
});